// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { SchemaModifier } from '../types';
import { generateKnowsAbout } from '../utils';
import { generateSchema } from '../SchemaGeneration';

const projectModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.project_funding) {
    main['sponsor'] = content.project_funding;
  }
  if (content?.project_volume) {
    main['funding'] = content.project_volume;
  }

  const knowsAbout = [
    ...(content?.research_areas || []),
    ...(content?.topics || []),
  ];
  if (knowsAbout.length > 0) {
    main['knowsAbout'] = generateKnowsAbout(knowsAbout);
  }

  if (content?.contacts) {
    main['contactPoint'] = content.contacts
      .filter((contact) => contact?.contact)
      .map((contact) => {
        return generateSchema({
          type: (contact.contact as Content)['@type'],
          content: contact.contact as Content,
          state,
          partial: true,
        });
      });
  }
};

export default projectModifier;
